import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './style.module.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartSimple,
  faBuildingCircleCheck,
  // faFolderPlus,
  // faChartLine,
  faPlus,
  faUpload,
  faFileCircleQuestion,
  faOutdent,
} from '@fortawesome/free-solid-svg-icons';

import defaultAvatar from '../../../assets/img/user-default-avatar.png';
import { faFile } from '@fortawesome/free-regular-svg-icons';
import { Footer } from '../../parts';

export default function DashboardLayout(props) {
  const { children } = props;

  const [hideSideBar, setHideSideBar] = useState(false);

  const mainNavigationData = [
    {
      id: 1,
      title: 'Dashboard',
      icon: faChartSimple,
      to: '/dashboard',
    },
    {
      id: 2,
      title: 'Fasilitas',
      icon: faBuildingCircleCheck,
      to: '/facility',
    },
    {
      id: 3,
      title: 'Kuesioner',
      icon: faFileCircleQuestion,
      to: '/questionnaire',
    },
    // {
    //   id: 4,
    //   title: 'Berkas Fasilitas',
    //   icon: faFolderPlus,
    //   to: '/facility-document',
    // },
    // {
    //   id: 5,
    //   title: 'Dashboard Perusahaan',
    //   icon: faChartLine,
    //   to: '/company-dashboard',
    // },
  ];

  return (
    <div className={styles.root}>
      <div className={styles.topDivider}></div>
      <div className={styles.dashboardContentWrapper}>
        <div
          className={`${styles.dashboardSidebar} ${hideSideBar && styles.hide}`}
        >
          <div className={styles.userArea}>
            <div>
              <img
                src={defaultAvatar}
                alt="User Avatar"
                className="userImage"
              />
              <h2 className={styles.userName}>User Name</h2>
            </div>
          </div>
          <div className={styles.navigationArea}>
            <div className={styles.mainNavigation}>
              <ul>
                {mainNavigationData.map((data) => (
                  <li key={`main-navigation-${data.id}`}>
                    <Link to={data.to}>
                      <FontAwesomeIcon
                        className={styles.mainNavItemIcon}
                        icon={data.icon}
                      />
                      <span className={styles.mainNavItem}>{data.title}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className={styles.additionalMenu}>
              <ul>
                <li className={styles.additionalMenuItem}>
                  <FontAwesomeIcon
                    className={styles.addNavItemIcon}
                    icon={faFile}
                  />
                  <span>Buat Laporan</span>
                </li>
                <li className={styles.additionalMenuItem}>
                  <FontAwesomeIcon
                    className={styles.addNavItemIcon}
                    icon={faPlus}
                  />
                  <span>Tambah Fasilitas</span>
                </li>
                <li className={styles.additionalMenuItem}>
                  <FontAwesomeIcon
                    className={styles.addNavItemIcon}
                    icon={faUpload}
                  />
                  <span>Upload Fasilitas</span>
                </li>
              </ul>
            </div>
          </div>

          <span
            className={styles.iconHide}
            onClick={() => setHideSideBar(true)}
          >
            <FontAwesomeIcon icon={faOutdent} />
          </span>
        </div>
        <div className={styles.dashboardChildren}>{children}</div>

        {hideSideBar && (
          <span
            className={styles.iconShow}
            onClick={() => setHideSideBar(false)}
          >
            <FontAwesomeIcon icon={faOutdent} />
          </span>
        )}
      </div>
      <div className={styles.bottomDivider}></div>
      <Footer />
    </div>
  );
}
